import { defineComponent as pe, useSlots as ye, defineAsyncComponent as M, computed as s, useAttrs as he, ref as B, createElementBlock as d, openBlock as u, normalizeClass as w, createVNode as R, createCommentVNode as L, unref as k, createSlots as G, withCtx as y, withDirectives as D, createBlock as N, resolveDynamicComponent as ke, mergeProps as H, createElementVNode as ge, toDisplayString as v, Fragment as S, renderList as P, createTextVNode as J, Suspense as xe, renderSlot as we, vShow as Le, nextTick as Se } from "vue";
import { RevPopover as $e } from "@ds/components/Popover";
import { deprecatePropNames as Ve } from "../../composables/usePropsDeprecation.js";
import { usePropsValidation as Ce } from "../../composables/usePropsValidation.js";
import { vFocus as j } from "../../directives/focus.js";
import { isEmpty as f } from "../../utils/isEmpty.js";
import { isEqual as Q } from "../../utils/isEqual.js";
import { omit as Ie } from "../../utils/omit.js";
import { tw as n } from "../../utils/tailwind.js";
import { componentHasFocus as Be } from "./InputSelect.helpers.js";
import De from "./components/InputSelectButton.vue2.js";
import Ne from "./components/InputSmallSelectButton.vue2.js";
const Pe = ["id", "aria-label", "disabled", "hidden", "value"], Te = ["id", "selected"], ze = ["disabled", "label"], Oe = ["disabled", "selected", "value"], _e = ["disabled", "selected", "value"], qe = ["id"], We = /* @__PURE__ */ pe({
  name: "RevInputSelect",
  inheritAttrs: !1,
  __name: "InputSelect",
  props: {
    autofocus: { type: Boolean, default: !1 },
    description: { default: void 0 },
    disabled: { type: Boolean, default: !1 },
    error: { default: void 0 },
    id: {},
    customListId: { default: "" },
    label: {},
    options: {},
    modelValue: {},
    size: { default: "medium" },
    variant: { default: "default" },
    required: { type: Boolean, default: !1 }
  },
  emits: ["change", "update:modelValue"],
  setup(c, { emit: U }) {
    const t = c, T = ye(), $ = U, W = M(
      () => import("../List/List.vue.js")
    ), X = M(
      () => import("./components/InputSelectItem.vue.js")
    ), Y = s(() => Ie(he(), ["class"])), b = s(
      () => !!T.optionPrefix || !!t.customListId
    );
    Ce({
      "If you choose to use a custom list, the `customListId` is required": () => !!T.optionPrefix && !t.customListId
    });
    const g = (e, l, a = "") => {
      const i = typeof e == "string" ? {
        disabled: !1,
        label: e,
        value: e
      } : e;
      return {
        key: `${f(a) ? "" : `${a}/`}${i.label}-${l}`,
        ...i
      };
    }, Z = B(null), m = s(
      () => t.size === "small" || t.variant === "tiny"
    ), V = B(!1), z = () => {
      V.value = !1;
    }, O = () => {
      V.value = !0;
    }, _ = s(() => t.options.some(
      (e) => JSON.stringify(e).includes(JSON.stringify(t.modelValue))
    )), ee = s(
      () => m.value ? `${t.id}-label-option` : void 0
    ), te = s(
      () => m.value ? t.label : void 0
    ), le = s(() => f(t.options) ? [] : t.options.filter((e) => {
      const { group: l, options: a } = e;
      return l && !f(a);
    }).reduce((e, l) => {
      const a = l, i = `${a.label}-${t.options.indexOf(l)}`;
      return [
        ...e,
        {
          disabled: a.disabled,
          key: i,
          label: a.label,
          options: a.options.map(
            (r, o) => g(r, o, i)
          )
        }
      ];
    }, [])), q = s(() => f(t.options) ? [] : t.options.filter((e) => !e.group).reduce((e, l) => [
      ...e,
      g(l, t.options.indexOf(l))
    ], [])), C = s(() => [
      ...q.value,
      ...le.value.reduce(
        (e, { options: l }) => [
          ...e,
          ...l
        ],
        []
      )
    ]), ae = s(() => f(t.options) ? [] : t.options.map((e, l) => {
      if (e.group) {
        const a = e, i = `${a.label}-${l}`;
        return {
          disabled: a.disabled,
          key: i,
          label: a.label,
          options: a.options.map(
            (r, o) => g(r, o, i)
          )
        };
      }
      return g(e, l);
    })), oe = (e) => e.options !== void 0, se = s(
      () => m.value ? Ne : De
    ), x = s(() => !f(t.error)), E = s(
      () => x.value ? t.error : t.description
    ), ie = s(() => {
      if (x.value)
        return x.value && `${t.id}_error`;
    }), re = (e) => {
      $("change", e);
      const l = C.value.find(
        ({ key: a }) => a === e.target.value
      );
      l !== void 0 && !f(l) && $("update:modelValue", l.value);
    }, ue = (e) => {
      $("update:modelValue", e.value);
    }, p = s(() => {
      const e = C.value.find(
        ({ value: l }) => Q(t.modelValue, l)
      );
      return e !== void 0 && !f(e) ? e.key : null;
    }), A = B([]), ne = async (e, l, a) => {
      if (Be(e)) {
        if (await Se(), p.value === l.key) {
          e.focus();
          return;
        }
        !p.value && a === 0 && e.focus();
      }
    };
    function F({
      isOpen: e,
      hide: l,
      show: a
    }) {
      return e ? l() : a();
    }
    const de = (e, { isOpen: l, hide: a, show: i }) => {
      e.key === "Enter" && (e.preventDefault(), e.stopPropagation(), F({ isOpen: l, hide: a, show: i }));
    }, ce = s(
      () => !m.value && !f(E.value)
    ), I = s(() => {
      const e = C.value.find(
        ({ value: l }) => Q(t.modelValue, l)
      );
      return e !== void 0 && !f(e) ? e.label : null;
    }), fe = s(() => [
      n`block w-full cursor-pointer pl-12`,
      m.value ? n`!leading-body-1-bold body-2-bold my-4 h-full pr-40` : n`body-1 pt-20`,
      t.disabled ? n`text-static-default-low-disabled` : n`text-static-default-hi`
    ]), me = n`!leading-body-1-bold body-2-bold size-full cursor-pointer pl-12 pr-40 pt-4`, K = s(() => m.value ? t.label : ""), ve = s(() => [
      n`body-2 mt-8`,
      t.disabled && n`text-static-default-low-disabled`,
      !t.disabled && t.error && n`text-static-danger-hi`,
      !t.disabled && !t.error && n`text-static-default-low`
    ]), be = s(() => [
      n`rounded-sm w-full cursor-pointer appearance-none border-0 bg-transparent pl-12 text-inherit outline-none`,
      m.value ? n`body-1-bold h-full pr-40` : n`body-1 pt-20`
    ]);
    return Ve([
      {
        reason: "Replaced by `size`, with new values `medium` (for `default`) and `small` (for `tiny`).",
        deadline: "2025-05-01",
        replacementName: "size",
        props: {
          propName: "variant",
          propValue: t.variant,
          propDefaultValue: "default"
        }
      }
    ]), (e, l) => (u(), d("div", {
      class: w(["relative", e.$attrs.class])
    }, [
      R(k($e), {
        "content-class-names": "z-10 w-full",
        position: "bottom-start"
      }, G({
        trigger: y(({ hide: a, isOpen: i, show: r }) => [
          D((u(), N(ke(se.value), H({
            ...b.value ? {
              "aria-expanded": i,
              "aria-controls": c.customListId,
              role: "combobox",
              onClick: () => F({ isOpen: i, hide: a, show: r }),
              onKeyDown: (o) => de(o, { isOpen: i, hide: a, show: r }),
              onBlur: z,
              onFocus: O
            } : {
              tabindex: -1
            }
          }, {
            disabled: c.disabled,
            focused: V.value,
            "has-error": x.value,
            "has-selected-option": _.value,
            required: c.required,
            "select-id": c.id
          }), G({
            value: y(() => [
              D((u(), d("select", H({ id: c.id }, Y.value, {
                ref_key: "select",
                ref: Z,
                "aria-label": te.value,
                class: be.value,
                disabled: c.disabled,
                hidden: b.value,
                value: p.value,
                onBlur: z,
                onChange: re,
                onFocus: O
              }), [
                ge("option", {
                  id: ee.value,
                  class: "bg-action-default-low text-static-default-hi",
                  disabled: "",
                  hidden: "",
                  selected: !_.value,
                  value: ""
                }, v(K.value), 9, Te),
                (u(!0), d(S, null, P(ae.value, (o) => (u(), d(S, null, [
                  oe(o) ? (u(), d("optgroup", {
                    key: `group_${o.key}`,
                    disabled: o.disabled,
                    label: o.label
                  }, [
                    (u(!0), d(S, null, P(o.options, (h) => (u(), d("option", {
                      key: h.key,
                      class: "bg-action-default-low text-static-default-hi",
                      disabled: h.disabled,
                      selected: h.key === p.value,
                      value: h.key
                    }, v(h.label), 9, Oe))), 128))
                  ], 8, ze)) : (u(), d("option", {
                    key: o.key,
                    class: "bg-action-default-low text-static-default-hi",
                    disabled: o.disabled,
                    selected: o.key === p.value,
                    value: o.key
                  }, v(o.label), 9, _e))
                ], 64))), 256))
              ], 16, Pe)), [
                [k(j), c.autofocus && !b.value]
              ]),
              b.value && !I.value && m.value ? (u(), d("p", {
                key: 0,
                class: w(me)
              }, v(K.value), 1)) : L("", !0),
              b.value && I.value ? (u(), d("output", {
                key: 1,
                class: w(fe.value)
              }, v(I.value), 3)) : L("", !0)
            ]),
            _: 2
          }, [
            m.value ? void 0 : {
              name: "label",
              fn: y(() => [
                J(v(c.label), 1)
              ]),
              key: "0"
            }
          ]), 1040, ["disabled", "focused", "has-error", "has-selected-option", "required", "select-id"])), [
            [k(j), c.autofocus && b.value]
          ])
        ]),
        _: 2
      }, [
        b.value ? {
          name: "content",
          fn: y(({ isOpen: a, hide: i }) => [
            a ? (u(), N(xe, { key: 0 }, {
              default: y(() => [
                D(R(k(W), {
                  id: c.customListId,
                  "aria-multiselectable": !1,
                  class: "bg-action-default-low shadow-long rounded-sm mt-8 overflow-y-auto",
                  role: "listbox"
                }, {
                  default: y(() => [
                    (u(!0), d(S, null, P(q.value, (r, o) => (u(), N(k(X), {
                      key: o,
                      id: `${r.label}-${o}`,
                      ref_for: !0,
                      ref_key: "customListItems",
                      ref: A,
                      "is-selected": r.key === p.value,
                      "items-center": !0,
                      label: r.label,
                      option: r,
                      onSelect: (h) => (ue(r), i()),
                      onVnodeMounted: () => ne(
                        A.value[o],
                        r,
                        o
                      )
                    }, {
                      prefix: y(() => [
                        we(e.$slots, "optionPrefix", {
                          index: o,
                          isSelected: r.key === p.value,
                          option: r
                        }, () => [
                          l[0] || (l[0] = J(v(""), -1))
                        ])
                      ]),
                      _: 2
                    }, 1032, ["id", "is-selected", "label", "option", "onSelect", "onVnodeMounted"]))), 128))
                  ]),
                  _: 2
                }, 1032, ["id"]), [
                  [Le, a && !t.disabled]
                ])
              ]),
              _: 2
            }, 1024)) : L("", !0)
          ]),
          key: "0"
        } : void 0
      ]), 1024),
      ce.value ? (u(), d("p", {
        key: 0,
        id: ie.value,
        class: w(ve.value)
      }, v(E.value), 11, qe)) : L("", !0)
    ], 2));
  }
});
export {
  We as default
};
